var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerkadaCamerasMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#001F97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1668 12H17.5881C17.7017 12.0001 17.8134 12.0291 17.9126 12.0845C18.0118 12.1398 18.0952 12.2196 18.1549 12.3163C18.2146 12.4129 18.2486 12.5232 18.2537 12.6367C18.2589 12.7502 18.2349 12.8631 18.1841 12.9647L16.8281 15.6773C16.7767 15.7801 16.6996 15.8679 16.6042 15.9321C16.5089 15.9963 16.3986 16.0347 16.284 16.0437C16.1694 16.0527 16.0545 16.0319 15.9503 15.9834C15.8461 15.9348 15.7563 15.8602 15.6894 15.7667L14.2734 13.7867M5.3335 16.6667H7.84016C8.08865 16.6684 8.33267 16.6007 8.54471 16.4711C8.75674 16.3415 8.92835 16.1552 9.04016 15.9333L10.0002 14M5.3335 18V15.3333M8.66683 10H8.6735M15.4042 10.0353C15.5622 10.1144 15.6824 10.253 15.7382 10.4206C15.7941 10.5882 15.7812 10.7712 15.7022 10.9293L13.6316 15.0699C13.5924 15.1483 13.5382 15.2181 13.472 15.2755C13.4059 15.3328 13.329 15.3766 13.246 15.4043C13.1629 15.432 13.0752 15.443 12.9878 15.4368C12.9005 15.4305 12.8152 15.4071 12.7369 15.3679L6.40688 12.1999C5.94711 11.9684 5.59779 11.5641 5.43536 11.0755C5.27294 10.587 5.31064 10.0541 5.54022 9.59328L6.46022 7.73328C6.57488 7.50476 6.73344 7.30107 6.92684 7.13383C7.12024 6.9666 7.34469 6.8391 7.58736 6.75862C7.83004 6.67814 8.0862 6.64626 8.3412 6.66479C8.5962 6.68332 8.84506 6.7519 9.07355 6.86661L15.4042 10.0353Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6929,
    y: 4.66284,
    width: 4.72261,
    height: 5.09349,
    rx: 1,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3007 5.6083L17.039 7.92903H17.0673L17.8071 5.6083H18.523L17.47 8.66284H16.6378L15.5833 5.6083H16.3007Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkadaCamerasMarker);
export default __webpack_public_path__ + "static/media/VerkadaCamerasMarker.16bfe2767f1654c55d338bef4e3d2d58.svg";
export { ForwardRef as ReactComponent };